import { LegalLinks } from "@/components/Legal";
import { GraphiteScope, Wordmark } from "@/components/Graphite";
import { cn } from "@/lib/utils";

// The public pages (no sign-in): /terms, /privacy, /refunds and /pricing. Graphite: a black header and
// footer in both themes around the page ground.
export default function PublicShell({ children, wide = false, testid, className }) {
  const width = wide ? "max-w-5xl" : "max-w-3xl";
  return (
    <GraphiteScope className="min-h-screen flex flex-col bg-background">
      <header className="dark bg-background text-foreground border-b">
        <div className={cn(width, "mx-auto px-4 sm:px-6 h-14 flex items-center")}>
          <Wordmark to="/" />
        </div>
      </header>
      <main className={cn(width, "w-full flex-1 mx-auto px-4 sm:px-6 py-12 sm:py-16", className)} data-testid={testid}>{children}</main>
      <footer className="dark bg-background text-foreground">
        <div className={cn(width, "mx-auto px-4 sm:px-6 py-8")}><LegalLinks /></div>
      </footer>
    </GraphiteScope>
  );
}
